export enum CellType {
    ICON = 'icon',
    ICON_MENU = 'iconMenu',
    FILL_BAR = 'fillBar',
    VIOLATIONS_MARKER = 'violations-marker',
    VIOLATIONS_MARKER_2 = 'violations-marker2',
    JSON_OBJECT = 'jsonObject',
    CHECKBOX = 'checkbox'
}
